<template>
  <b-modal
    ref="modal"
    title="Nuovi componenti nucleo familiare"
    size="xl"
    class="large"
    centered
    no-close-on-backdrop
  >

    <div class="box mb-3">

      <div class="col-12 box-header">Dati generali</div>
      <div class="row box-body">

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Nome</label>
          <b-input
            v-model.trim="familiare.nome"
            type="text"
            :formatter="formatUcase"
            size="sm"
            :state="fieldState('nome')"
          />
          <b-form-invalid-feedback v-if="!$v.familiare.nome.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Cognome</label>
          <b-input
            v-model.trim="familiare.cognome"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
            :state="fieldState('cognome')"
          />
          <b-form-invalid-feedback v-if="!$v.familiare.cognome.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Data di nascita</label>
          <b-input
            v-model="familiare.dataNascita"
            type="date"
            size="sm"
            :state="fieldState('dataNascita')"
          />
          <b-form-invalid-feedback v-if="!$v.familiare.dataNascita.required">Campo obbligatorio</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.familiare.dataNascita.verificaNascita">Verificare anno di nascita.</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Codice Fiscale</label>
          <b-input
            v-model="familiare.codiceFiscale"
            type="text"
            :formatter="formatUcase"
            size="sm"
            :state="fieldState('codiceFiscale')"
          />
          <b-form-invalid-feedback v-if="!$v.familiare.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="!$v.familiare.codiceFiscale.codiceFiscaleExtended">Codice fiscale non corretto</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Comune di nascita</label>
          <b-input
            v-model.trim="familiare.comuneNascita"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
            :state="fieldState('comuneNascita')"
          />
          <b-form-invalid-feedback v-if="!$v.familiare.comuneNascita.required">Campo obbligatorio</b-form-invalid-feedback>
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Provincia</label>
          <b-input
            v-model.trim="familiare.provinciaNascita"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
            :state="fieldState('provinciaNascita')"
          />
          <!--b-form-invalid-feedback v-if="!$v.familiare.provinciaNascita.required">Campo obbligatorio</b-form-invalid-feedback-->
        </div>

      </div>
    </div>
    <span> a seguito di: </span>
    <b-form inline>
      <b-check
        v-model="familiare.legami.matrimonio.spunta"
        @change="emptyData"
      />
      <span class="mr-2"> matrimonio del sottoscritto assegnatario in data:</span>
      <b-input
        :disabled="!familiare.legami.matrimonio.spunta"
        v-model="familiare.legami.matrimonio.data"
        type="date"
        size="xs"
      />
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <b-check
        v-model="familiare.legami.unioneCivile.spunta"
        @change="emptyData"
      />
      <span class="mr-2">unione civile del sottoscritto assegnatario in data:</span>
      <b-input
        :disabled="!familiare.legami.unioneCivile.spunta"
        v-model="familiare.legami.unioneCivile.data"
        type="date"
        size="xs"
      />
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <b-check
        v-model="familiare.legami.convivenza.spunta"
        @change="emptyData"
      />
      <span class="mr-2">convivenza di fatto del sottoscritto assegnatario ai sensi della Legge n. 76/2016 in data:</span>
      <b-input
        :disabled="!familiare.legami.convivenza.spunta"
        v-model="familiare.legami.convivenza.data"
        type="date"
        size="xs"
      />
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <b-check v-model="familiare.legami.accrescimentoProle.spunta" />
      <span>accrescimento della prole del sottoscritto assegnatario (nascita/adozione/ riconoscimento);</span>
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <b-check
        v-model="familiare.legami.affidamento.spunta"
        @change="emptyData"
      />
      <span class="mr-2">affidamento di minore al sottoscritto assegnatario con provvedimento del Tribunale di</span>
      <b-input
        style="width:11rem"
        :disabled="!familiare.legami.affidamento.spunta"
        v-model="familiare.legami.affidamento.tribunale"
        type="text"
        size="sm"
      />
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <span class="mr-2 ml-4"> n.</span>
      <b-input
        style="width:6rem"
        :disabled="!familiare.legami.affidamento.spunta"
        v-model="familiare.legami.affidamento.numeroAtto"
        type="text"
      />
      <span class="mr-2 ml-2"> del </span>
      <b-input
        :disabled="!familiare.legami.affidamento.spunta"
        v-model="familiare.legami.affidamento.data"
        type="date"
        size="sm"
      /><span class="ml-2">(allegare provvedimento);</span>
    </b-form>
    <b-form
      inline
      class="mt-3"
    >
      <b-check v-model="familiare.legami.rientroFiglio.spunta">ingresso o rientro del figlio del sottoscritto assegnatario ai sensi dell’art. 12, comma 4, lettera e);</b-check>
    </b-form>

    <b-form
      inline
      class="mt-3"
    >
      <b-check v-model="familiare.legami.rientroParentiII.spunta">ingresso o rientro dei parenti di secondo grado del sottoscritto assegnatario ai sensi dell’art. 12, comma 4, lettera e);</b-check>
    </b-form>

    <b-form
      inline
      class="mt-3"
    >
      <b-check v-model="familiare.legami.rientroConvivente.spunta">rientro del coniuge, o parte dell'unione civile o convivente di fatto ai sensi della normativa statale vigente in materia, ai sensi dell’art. 12, comma 4, lettera e).</b-check>
    </b-form>

    <template slot="modal-footer">

      <b-button
        v-if="idx===-1"
        variant="success"
        @click="add"
      >
        <font-awesome-icon icon="plus" /> Aggiungi
      </b-button>

      <b-button
        v-else
        variant="success"
        @click="update"
      >
        <font-awesome-icon icon="edit" /> Aggiorna
      </b-button>

      <b-button
        v-if="idx!==-1"
        variant="danger"
        @click="remove"
      >
        <font-awesome-icon
          icon="trash-alt"
          class="mr-2"
        /> Rimuovi componente
      </b-button>

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        /> Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import cloneDeep from 'lodash/cloneDeep'
import CodiceFiscale from '../utils/codice-fiscale'
// import ModelloForm from '@/components/ModelloForm'
// import numeral from 'numeral'
import 'numeral/locales'

// const codiceFiscale = (value, vm) => {
//   if (!value) return true
//   try {
//     let cf1 = CodiceFiscale.computeInverse(value)
//     if (vm.dataNascita) {
//       let dn = vm.dataNascita.split('-')
//       cf1.name = vm.nome
//       cf1.surname = vm.cognome
//       cf1.day = parseInt(dn[2])
//       cf1.month = parseInt(dn[1])
//       cf1.year = parseInt(dn[0])
//       let cf2 = CodiceFiscale.compute(cf1)
//       return cf2.substr(0, 15) === value.toUpperCase().substr(0, 15)
//     }
//     return true
//   } catch (err) {
//     return false
//   }
// }

const codiceFiscaleExtended = (value, vm) => {
  let idRet = true
  if (!value) idRet = false
  try {
    let cf1 = CodiceFiscale.computeInverse(value)
    if (vm.dataNascita && idRet) {
      let dn = vm.dataNascita.split('-')
      cf1.name = vm.nome
      cf1.surname = vm.cognome
      cf1.day = parseInt(dn[2])
      cf1.month = parseInt(dn[1])
      cf1.year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', cf1.year, cf1.year < 1900, cf1.year > new Date().getFullYear())
      if (cf1.year < 1900 || cf1.year > new Date().getFullYear()) {
        idRet = false
      } else {
        let cf2 = CodiceFiscale.compute(cf1)
        idRet = cf2.substr(0, 15) === value.toUpperCase().substr(0, 15)
      }
      return idRet
    }
    return true
  } catch (err) {
    return false
  }
}

const verificaNascita = (value, vm) => {
  let idRet = true
  if (!value) idRet = false
  try {
    if (vm.dataNascita && idRet) {
      let dn = vm.dataNascita.split('-')
      let year = parseInt(dn[0])
      // L'anno deve essere compreso tra l'anno corrente ed il 1900
      // console.log('Verifica anno', year, year < 1900, year > new Date().getFullYear())
      if (year < 1900 || year > new Date().getFullYear()) idRet = false
    }
    return idRet
  } catch (err) {
    return false
  }
}

export default {
  name: 'FamiliareModal',

  data () {
    return {
      item: {},
      familiare: this.emptyFamiliare(),
      allegato: this.emptyAllegato(),
      idx: -1
    }
  },

  validations: {
    familiare: {
      nome: { required },
      cognome: { required },
      dataNascita: { required, verificaNascita },
      codiceFiscale: { required, codiceFiscaleExtended },
      comuneNascita: { required },
      provinciaNascita: {}
      // legami:{matrimonio:{spunta:Boolean, data:''}}
    }
  },

  methods: {
    emptyData () {
      // console.log('spunta', this.familiare.legami.matrimonio.spunta)
      if (this.familiare.legami.matrimonio.spunta) {
        this.familiare.legami.matrimonio.data = ''
      }
      if (this.familiare.legami.unioneCivile.spunta) {
        this.familiare.legami.unioneCivile.data = ''
      }
      if (this.familiare.legami.convivenza.spunta) {
        this.familiare.legami.convivenza.data = ''
      }
      if (this.familiare.legami.affidamento.spunta) {
        this.familiare.legami.affidamento.tribunale = ''
        this.familiare.legami.affidamento.numeroAtto = ''
        this.familiare.legami.affidamento.data = ''
      }
    },
    emptyFamiliare () {
      return {
        nome: '',
        cognome: '',
        dataNascita: '',
        codiceFiscale: '',
        numeroComponente: 1,
        comuneNascita: '',
        provinciaNascita: '',
        legami: {
          matrimonio: { spunta: false, data: null },
          unioneCivile: { spunta: false, data: null },
          convivenza: { spunta: false, data: null },
          accrescimentoProle: { spunta: false },
          affidamento: { spunta: false, tribunale: null, numeroAtto: null, data: null },
          rientroFiglio: { spunta: false },
          rientroParentiII: { spunta: false },
          rientroConvivente: { spunta: false }
        }
      }
    },
    emptyAllegato () {
      return {
        idAllegato: '',
        descrizione: '',
        fileName: '',
        templateId: 'componenteAggiuntivo',
        uploaded: '',
        codiceFiscale: ''
      }
    },

    allegatiStart () {
      let allegati = []
      let allegatoA = this.emptyAllegato()
      allegatoA.idAllegato = 'a'
      allegatoA.descrizione = 'COMUNICAZIONE AMPLIAMENTO NUCLEO FAMILIARE'
      allegatoA.codiceFiscale = ''
      allegatoA.templateId = 'ampliamentoNucleoFamiliare'
      allegati.push(allegatoA)

      let allegatoB = this.emptyAllegato()
      allegatoB.idAllegato = 'b'
      allegatoB.descrizione = '“AMPLIAMENTO – note” firmato per presa visione'
      allegatoB.codiceFiscale = ''
      allegatoB.templateId = 'ampliamentoNote'
      allegati.push(allegatoB)

      let allegatoC = this.emptyAllegato()
      allegatoC.idAllegato = 'c'
      allegatoC.descrizione = '“prospetto redditi” compilato e sottoscritto'
      allegatoC.codiceFiscale = ''
      allegatoC.templateId = 'prospettoRedditiPatrimonio'
      allegatoC.standard = true
      allegati.push(allegatoC)

      let allegatoD = this.emptyAllegato()
      allegatoD.idAllegato = 'd'
      allegatoD.descrizione = 'copia documento d’identità in corso di validità dell’assegnatario'
      allegatoD.codiceFiscale = ''
      allegatoD.templateId = ''
      allegati.push(allegatoD)

      let allegatoE = this.emptyAllegato()
      allegatoE.idAllegato = 'e'
      allegatoE.descrizione = 'copia documento d’identità in corso di validità del Componente 1'
      allegatoE.codiceFiscale = ''
      allegatoE.templateId = ''
      allegati.push(allegatoE)

      return allegati
    },

    fieldState (field) {
      let v = this.$v.familiare[field]
      return v.$dirty && v.$error ? false : null
    },

    async open ({ item, idx }) {
      this.$v.$reset()
      this.item = item
      this.idx = idx >= 0 ? idx : -1
      let familiare = idx >= 0 ? cloneDeep(item.nuoviFamiliari[idx]) : this.emptyFamiliare()
      if (!familiare.legami) {
        familiare.legami = {
          matrimonio: { spunta: false, data: null },
          unioneCivile: { spunta: false, data: null },
          convivenza: { spunta: false, data: null },
          accrescimentoProle: { spunta: false },
          affidamento: { spunta: false, tribunale: null, numeroAtto: null, data: null },
          rientroFiglio: { spunta: false }
        }
      }
      // if (!familiare.modelli) familiare.modelli = []
      this.familiare = familiare
      // await this.$store.dispatch('options/loadTipoComponenteOptions')
      // console.log('visualizza familiare', this.familiare)
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    validate () {
      this.$v.$touch()
      return !this.$v.$invalid
    },

    add () {
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        if (!this.item.nuoviFamiliari) this.$set(this.item, 'nuoviFamiliari', [this.familiare])
        else {
          this.familiare.numeroComponente = this.item.nuoviFamiliari.length + 1
          this.item.nuoviFamiliari.push(this.familiare)
        }

        // Se necessario aggiungere riga a tabella allegati per componente aggiuntivo.
        if (this.item.nuoviFamiliari.length > 1) {
          // Aggiungo allegato componenteAggiuntivo
          let idxAllegato = this.item.allegati ? this.item.allegati.length - 1 : 0
          let appId = 'a'
          if (idxAllegato > 0) {
            appId = this.item.allegati[idxAllegato].idAllegato
          }
          // let appId = this.item.allegati[idxAllegato].idAllegato
          this.allegato.idAllegato = String.fromCharCode(appId.charCodeAt(0) + 1)
          this.allegato.descrizione = 'Comunicazione ampliamento per componente aggiuntivo ' + (this.item.nuoviFamiliari.length)
          this.allegato.codiceFiscale = this.familiare.codiceFiscale

          if (!this.item.allegati) {
            this.$set(this.item, 'allegati', this.allegatiStart())
          }

          this.item.allegati.push(this.allegato)

          // Aggiungo allegato documento identità componenteAggiuntivo
          appId = this.item.allegati[this.item.allegati.length - 1].idAllegato
          let allegatoDoc = this.emptyAllegato()
          allegatoDoc.idAllegato = String.fromCharCode(appId.charCodeAt(0) + 1)
          // allegatoDoc.descrizione = 'copia documento d’identità in corso di validità del Componente ' + (this.item.nuoviFamiliari.length)
          allegatoDoc.descrizione = 'copia documento d’identità in corso di validità del Componente ' + this.familiare.cognome + ' ' + this.familiare.nome
          allegatoDoc.codiceFiscale = this.familiare.codiceFiscale
          allegatoDoc.templateId = ''

          this.item.allegati.push(allegatoDoc)

          // console.log('Allegato per nuovo componente', this.item.allegati.length, appId, this.allegato, this.item.allegati)
        } else {
          if (!this.item.allegati || this.item.allegati.length === 0) {
            // console.log('Imposta allegati start', this.item.allegati, !!this.item.allegati)
            this.$set(this.item, 'allegati', this.allegatiStart())
          }
        }

        // console.log('nuoviFamiliari e familiare', this.item.nuoviFamiliari, this.familiare, this.item.allegati, this.allegato)
        this.close()
      }
    },

    update () {
      // console.log('spunta Update', this.familiare.legami.matrimonio)
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        this.familiare.numeroComponente = this.idx + 1
        this.$set(this.item.nuoviFamiliari, this.idx, this.familiare)
        this.close()
      }
    },

    remove () {
      // Rimuovere le relative righe di allegati aggiuntivi.
      // Nel caso vanno rimossi anche i file allegati già uploadati. Va richiesta eventuale conferma.
      if (this.item.nuoviFamiliari.length > 1) {
        // OK posso cancellare le righe corrispondenti al componente (vedi CF)
        let mapIndex = this.item.allegati.map((item, i) => {
          // console.log('mapIndex item', item.codiceFiscale, item)
          return item.codiceFiscale === this.familiare.codiceFiscale ? i : ''
        }).filter(String)
        // console.log('Elementi da cancellare', mapIndex, this.item.allegati, this.familiare.codiceFiscale)
        if (mapIndex.length > 0) {
          this.item.allegati.splice(mapIndex[0], 2)
          this.item.allegati.forEach((element, index, array) => {
            if (index > 3) {
              let appId = this.item.allegati[index - 1].idAllegato
              element.idAllegato = String.fromCharCode(appId.charCodeAt(0) + 1)
            }
          })
        }
      } else {
        // Rimuovere le righe per il primo compponente (a-e)
        this.item.allegati.splice(0, this.item.allegati.length)
      }

      this.item.nuoviFamiliari.splice(this.idx, 1)

      this.close()
    },
    formatUcase (value, event) {
      return value.toUpperCase()
    }
  }
}

</script>

<style lang="stylus" scoped>
.scrollable {
  max-height: max(20rem, 50vh);
  overflow-y: scroll;
}

.large >>> .modal-xl {
  min-width: 60rem !important;
}
</style>
